var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 10
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("审核流名称")
    }
  }, [_c("a-input", {
    attrs: {
      "max-length": 50,
      placeholder: _vm.$t("请输入") + _vm.$t("审核流名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "type",
      label: _vm.$t("创建类型")
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: _vm.dataFrom.auditFlowId ? true : false
    },
    model: {
      value: _vm.dataFrom.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type", $$v);
      },
      expression: "dataFrom.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "SYSTEM",
      name: "type"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("系统审核流")) + " ")]), _c("a-radio", {
    attrs: {
      value: "DIY",
      name: "type"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("客户自定义审核流")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "flowTypeId",
      label: _vm.$t("审核流类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核流类型"),
      allowClear: "",
      disabled: _vm.dataFrom.auditFlowId ? true : false
    },
    model: {
      value: _vm.dataFrom.flowTypeId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "flowTypeId", $$v);
      },
      expression: "dataFrom.flowTypeId"
    }
  }, _vm._l(_vm.flowTypeList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "flowMark",
      label: _vm.$t("标识")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("标识"),
      allowClear: "",
      disabled: _vm.dataFrom.auditFlowId ? true : false
    },
    on: {
      change: _vm.flowMarkChangeFun
    },
    model: {
      value: _vm.dataFrom.flowMark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "flowMark", $$v);
      },
      expression: "dataFrom.flowMark"
    }
  }, _vm._l(_vm.markList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("归属客户"),
      prop: "customerId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("归属客户"),
      disabled: _vm.dataFrom.auditFlowId ? true : false,
      "show-search": "",
      "option-filter-prop": "children"
    },
    on: {
      change: _vm.customIdChange
    },
    model: {
      value: _vm.dataFrom.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "customerId", $$v);
      },
      expression: "dataFrom.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _vm.dataFrom.customerId && _vm.dataFrom.flowMark != "version_online" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("客户应用"),
      prop: "applicationId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("应用"),
      disabled: _vm.disabledFun()
    },
    on: {
      change: _vm.getProductFun
    },
    model: {
      value: _vm.dataFrom.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "applicationId", $$v);
      },
      expression: "dataFrom.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(" " + _vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ") ")]);
  }), 1)], 1) : _vm._e(), _vm.dataFrom.customerId && _vm.dataFrom.flowMark === "questionnaire" ? _c("a-form-model-item", {
    attrs: {
      prop: "userId",
      label: _vm.$t("可见人员")
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "show-search": "",
      "dropdown-style": {
        maxHeight: "400px",
        overflow: "auto"
      },
      "allow-clear": "",
      multiple: "",
      treeNodeLabelProp: "label",
      placeholder: _vm.$t("请选择") + _vm.$t("可见人员"),
      disabled: !_vm.dataFrom.customerId,
      "tree-data": _vm.visiblePersonnelData
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.dataFrom.userId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "userId", $$v);
      },
      expression: "dataFrom.userId"
    }
  })], 1) : _vm._e(), _vm.dataFrom.applicationId && _vm.dataFrom.flowMark != "version_online" && _vm.dataFrom.flowMark != "questionnaire" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品"),
      prop: _vm.productPropFun(_vm.dataFrom.flowMark)
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("产品"),
      allowClear: "",
      disabled: _vm.disabledFun2(),
      mode: _vm.productModeFun(_vm.dataFrom.flowMark)
    },
    on: {
      change: _vm.getProductTypeFun
    },
    model: {
      value: _vm.customerInsuranceId,
      callback: function ($$v) {
        _vm.customerInsuranceId = $$v;
      },
      expression: "customerInsuranceId"
    }
  }, _vm._l(_vm.productList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.customerInsuranceId
      }
    }, [_vm._v(" " + _vm._s(item.mark) + " /" + _vm._s(item.insuranceName) + " ")]);
  }), 1), _vm.dataFrom.flowMark == "product_launch" || _vm.dataFrom.flowMark == "product_change" ? _c("div", [_vm._v(" " + _vm._s(_vm.$t("未选择产品时，审核流将作用到所选应用上全部产品")) + " ")]) : _vm._e()], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  }), _c("div", {
    staticClass: "tip"
  }, [_vm._v("* " + _vm._s(_vm.$t("未选择可见人员，审核流将应用到该所属客户下的所有人员")))])], 1), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 5
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };